export const getFeedImageAssetPathAsUrl = (path: string, baseUrl?: string): string => {
    const assetBase = baseUrl ?? process.env['NEXT_PUBLIC_LEARNING_ASSETS_BASE_URL'];

    if (path.startsWith('./')) {
        path = path.slice(2);
    } else if (path.startsWith('/')) {
        path = path.slice(1);
    }

    return `${assetBase}/${path}`;
}

export const getFeedSpeechAssetPathAsUrl = (path: string, baseUrl?: string): string => {
    return getFeedImageAssetPathAsUrl(path, baseUrl);
}